import {Component, OnInit} from '@angular/core';
import {ClinicalCaseService} from '../../../services/clinical-case.service';

@Component({
  selector: 'app-info-generale',
  templateUrl: './general-info.component.html',
  styleUrls: ['./general-info.component.css']
})
export class GeneralInfoComponent implements OnInit {

  step = 0;
  idCreator = '';
  difficulty = '';
  fields = '';
  name = '';
  careContext = '';

  constructor(private clinicalCaseService: ClinicalCaseService) {
  }

  ngOnInit(): void {
    this.idCreator = this.clinicalCaseService.getClinicalCase().idCreator;
    this.difficulty = this.clinicalCaseService.getClinicalCase().difficulty;
    this.fields = this.clinicalCaseService.getClinicalCase().fields;
    this.name = this.clinicalCaseService.getClinicalCase().name;
    this.careContext = this.clinicalCaseService.getClinicalCase().careContext;
  }

  saveData(): void {
    this.clinicalCaseService.saveGeneralInfo(this.name, this.fields, this.idCreator, this.difficulty, this.careContext);
  }
}
